<template lang="pug">
.form-block.box
  div(:class="{ 'is-deleted': block.is_deleted }")
    b-field(grouped)
      b-field(label="Section Type")
        form-block-type-select(
          :value="block.type"
          @input="saveBlockField($event, 'type')"
        )
      b-field(label="Heading" expanded)
        b-input(
          type="text"
          :value="block.heading"
          @change.native="saveBlockField($event, 'heading')"
        )
      //- b-field(v-if="b !== 0" label="S")
      //-   a.button.is-danger(@click="confirmDelete(b)")
      //-     b-icon(icon="close")
    b-field(label="Paragraph")
      b-input(
        type="textarea"
        rows="2"
        :value="block.paragraph"
        @change.native="saveBlockField($event, 'paragraph')"
      )
    div(v-if="block.type === 'payment'")
      .notification Credit card fields will go here. Ensure that payment settings are properly configured for the event.
    .form-fields(v-else)
      b-table(
        :data="block.form_fields"
        @dragstart="dragstart"
        @dragover="dragover"
        @dragleave="dragleave"
        @drop="drop"
        draggable
      )
        template(slot-scope="props")
          b-table-column
            b-icon.drag-icon.has-text-grey-light(icon="drag-vertical")
          b-table-column(label="Required" width="30")
            template(slot="header" slot-scope="{ column }")
              b-tooltip(
                type="is-dark"
                position="is-right"
                label="The user must fill out this field to submit the form"
                multilined
              )
                span {{ column.label }}
                b-icon(icon="help-circle-outline" size="is-small")
            b-checkbox(
              :centered="true"
              :value="props.row.is_required"
              @input="set($event, props.index, 'is_required')"
            )
          b-table-column(label="Report" width="30")
            template(slot="header" slot-scope="{ column }")
              b-tooltip(
                type="is-dark"
                position="is-right"
                label="Checked fields are listed in the sign up table"
                multilined
              )
                span {{ column.label }}
                b-icon(icon="help-circle-outline" size="is-small")
            b-checkbox(
              :centered="true"
              :value="props.row.is_featured"
              @input="set($event, props.index, 'is_featured')"
            )
          b-table-column(label="Type" width="200")
            b-field
              p.control.field-type-select-wrapper
                field-type-select(
                  :value="props.row.type"
                  @input="set($event, props.index, 'type')"
                  expanded
                )
              p.control
                a.button(
                  :disabled="!hasOptions(props.row)"
                  @click="openFieldOptions(props.row)"
                )
                  b-icon(icon="settings")
          b-table-column(label="Field Label")
            template(slot="header" slot-scope="{ column }")
              b-tooltip(
                type="is-dark"
                position="is-right"
                label="Text above the field. Set the field or the placedholder, but not both."
                multilined
              )
                span {{ column.label }}
                b-icon(icon="help-circle-outline" size="is-small")
            b-input(
              :value="props.row.label"
              :disabled="props.row.type === 'waiver'"
              @change.native="set($event, props.index, 'label')"
            )
          b-table-column(label="Field Placeholder")
            template(slot="header" slot-scope="{ column }")
              b-tooltip(
                type="is-dark"
                position="is-right"
                label="Text inside the field. Set the placeholder or the field, but not both."
                multilined
              )
                span {{ column.label }}
                b-icon(icon="help-circle-outline" size="is-small")
            b-input(
              :value="props.row.placeholder"
              :disabled="props.row.type === 'waiver'"
              @change.native="set($event, props.index, 'placeholder')"
            )
          b-table-column(label="Options")
            template(slot="header" slot-scope="{ column }")
              b-tooltip(
                type="is-dark"
                position="is-right"
                label="A list of the options the user can choose from (e.g. S, M, L, XL)"
                multilined
              )
                span {{ column.label }}
                b-icon(icon="help-circle-outline" size="is-small")
            b-input(
              :value="props.row.options_list"
              :disabled="props.row.type !== 'select'"
              :placeholder="props.row.type === 'select' ? 'Separated by commas' : ''"
              @change.native="set($event, props.index, 'options_list')"
            )
          b-table-column(width="100" numeric)
            b-field(grouped)
              p.control
                a.button(@click="addField(props.index)")
                  b-icon(icon="plus")
              p.control
                a.button.is-danger(@click="deleteField(props.index)")
                  b-icon(icon="close")
    .form-block-ctas
      b-field(grouped)
        b-field
          a.button(@click="addBlock('before')")
            b-icon(icon="table-row-plus-before")
            span Add Section Before
        b-field
          a.button(@click="addBlock('after')")
            b-icon(icon="table-row-plus-after")
            span Add Section After
        b-field
          a.button.is-danger(@click="confirmDeleteBlock")
            b-icon(icon="close")
            span Delete Section
</template>

<script>
import { mapGetters } from 'vuex';
import FieldOptionsForm from '@/components/form/FieldOptionsForm';
import FieldTypeSelect from '@/components/form/FieldTypeSelect';
import FormBlockTypeSelect from '@/components/form/FormBlockTypeSelect';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'form-block',
  components: {
    FieldTypeSelect,
    FormBlockTypeSelect,
  },
  computed: {
    ...mapGetters({
      form: getters.GET_FORM,
    }),
    block() {
      return this.value;
    },
  },
  data() {
    return {
      dragging: null,
    };
  },
  methods: {
    async addBlock(direction) {
      let index = direction === 'before' ? this.index : this.index + 1;
      if (index < 0) index = 0;
      const { data } = await this.$store.dispatch(actions.DO_CREATE_FORM_BLOCK, {
        id: this.form.id,
        sort_order: index,
        type: 'custom',
      });
      this.$store.commit(mutations.SET_FORM_REFRESH, true);
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Form section added',
      });
      return data;
    },
    async addField(index) {
      const { data } = await this.$store.dispatch(actions.DO_CREATE_FORM_FIELD, {
        id: this.block.id,
        type: 'text',
      });
      this.$store.commit(mutations.ADD_FORM_FIELD_FOR_BLOCK, {
        block_id: this.block.id,
        index: index + 1,
        field: data.form_fields[0],
      });
      this.block = this.value;
      return this.saveFields();
    },
    confirmDeleteBlock() {
      this.$buefy.dialog.confirm({
        title: 'Are you sure?',
        message: 'Deleting this section cannot be undone',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.deleteBlock(),
      });
    },
    async deleteBlock() {
      await this.$store.dispatch(actions.DO_DELETE_FORM_BLOCK, {
        id: this.block.id,
      });
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Form section deleted',
      });
      this.$store.commit(mutations.SET_FORM_REFRESH, true);
    },
    async deleteField(index) {
      const field = this.block.form_fields[index];
      await this.$store.dispatch(actions.DO_DELETE_FORM_FIELD, {
        id: field.id,
      });
      this.$store.commit(mutations.REMOVE_FORM_FIELD_FOR_BLOCK, {
        block_id: this.block.id,
        index,
      });
      this.block = this.value;
      return this.saveFields();
    },
    dragstart(payload) {
      this.dragging = payload.index;
      payload.event.dataTransfer.effectAllowed = 'copy';
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy';
      payload.event.target.closest('tr').classList.add('is-selected');
      payload.event.preventDefault();
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      payload.event.preventDefault();
    },
    async drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected');
      this.$store.commit(mutations.MOVE_FORM_FIELD_FOR_BLOCK, {
        block_id: this.block.id,
        from: this.dragging,
        to: payload.index,
      });
      await this.saveFields();
      this.$store.commit(mutations.SET_APP_SNACKBAR, {
        type: 'is-success',
        message: 'Sort order updated',
      });
    },
    hasOptions(field) {
      const fields = [
        'number',
        'select',
        'textarea',
        'waiver',
      ];
      return fields.includes(field.type);
    },
    async openFieldOptions(field) {
      if (this.hasOptions(field)) {
        this.$store.commit(mutations.SET_FORM_FIELD, field);
        this.$buefy.modal.open({
          parent: this,
          component: FieldOptionsForm,
          hasModalCard: true,
        });
      }
    },
    async saveBlockField($event, key) {
      const val = typeof $event === 'object' ? $event.target.value : $event;
      this.$store.commit(mutations.SET_FIELD_FOR_BLOCK, {
        key,
        val,
        block_id: this.block.id,
      });
      const payload = { id: this.block.id };
      payload[key] = val;
      await this.$store.dispatch(actions.DO_UPDATE_FORM_BLOCK, payload);
      this.$store.commit(mutations.SET_FORM_REFRESH, true);
    },
    async saveFields() {
      const fieldActions = [];
      let i = 0;
      this.block.form_fields.forEach((field) => {
        const payload = {
          id: field.id,
          sort_order: i,
        };
        fieldActions.push(this.$store.dispatch(actions.DO_UPDATE_FORM_FIELD, payload));
        i += 1;
      });
      await Promise.all(fieldActions);
      this.$store.commit(mutations.SET_FORM_REFRESH, true);
      return Promise.resolve();
    },
    async set($event, index, key) {
      const val = typeof $event === 'object' ? $event.target.value : $event;
      const field = this.block.form_fields[index];
      this.$store.commit(mutations.SET_FIELD_FOR_BLOCK_FIELD, {
        key,
        val,
        block_id: this.block.id,
        field_index: index,
      });
      const payload = { id: field.id };
      payload[key] = val;
      await this.$store.dispatch(actions.DO_UPDATE_FORM_FIELD, payload);
      this.$store.commit(mutations.SET_FORM_REFRESH, true);
    },
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.form-block {
  border-radius: 4px;
  table.table {
    thead {
      tr {
        th:first-child {
          padding-left: 0;
        }
        th:last-child {
          padding-right: 0;
        }
      }
    }
    tbody {
      tr {
        td {
          vertical-align: middle;
          .drag-icon {
            cursor: move;
          }
          .field {
            .field-type-select-wrapper {
              flex: 1;
            }
            .field {
              margin-bottom: 0 !important;
            }
          }
        }
        td:first-child {
          padding-left: 0;
        }
        td:last-child {
          padding-right: 0;
          .field {
            float: right;
          }
        }
      }
    }
  }
  .form-block-ctas {
    padding-top: 1.25rem;
    .field.is-grouped {
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/form/FormBlock.vue